import { Injectable } from "@angular/core";
import { lastValueFrom, Observable } from "rxjs";
import { DataResult, ICRUD } from '@phx-erp/shared';
import { BaseListService } from "../../../@core/services/base-list.service";
import { SystemService } from "../../../@core/services/system.service";
import { DELETE_DISCOUNT_GROUP_CUSTOMER_RELATION, GET_DISCOUNT_GROUP_CUSTOMER_RELATION, GET_DISCOUNT_GROUP_CUSTOMER_RELATIONS, SAVE_DISCOUNT_GROUP_CUSTOMER_RELATION } from "../../../data/definitions/discount-group-customer-relation.definition";
import { QueryResult } from "../../../data/query-result";
import { BaseDataService } from "../../../data/services/base-data.service";
import { DeleteDiscountGroupCustomerRelationMutation, DeleteDiscountGroupCustomerRelationMutationVariables, DeletionResponse, DiscountGroupCustomerRelation, DiscountGroupCustomerRelationInput, DiscountGroupCustomerRelationSearchInput, GetDiscountGroupCustomerRelationQuery, GetDiscountGroupCustomerRelationQueryVariables, GetDiscountGroupCustomerRelationsQuery, GetDiscountGroupCustomerRelationsQueryVariables, SaveDiscountGroupCustomerRelationMutation, SaveDiscountGroupCustomerRelationMutationVariables } from "../../../generated/generated-types";

@Injectable({
    providedIn: 'root'
})
export class DiscountGroupCustomerRelationService extends BaseListService<DiscountGroupCustomerRelation> implements ICRUD<DiscountGroupCustomerRelation> {
    constructor(
        private baseDataService: BaseDataService,
        private systemService: SystemService,
    ) {
        super();
    }

    getData(searchInput?: DiscountGroupCustomerRelationSearchInput/*, options?: ICRUDOptions*/): Observable<DataResult<DiscountGroupCustomerRelation>> {
        return super.getData(searchInput);
    }

    getItems(searchInput: DiscountGroupCustomerRelationSearchInput): QueryResult<GetDiscountGroupCustomerRelationsQuery> {
        let fragment = GET_DISCOUNT_GROUP_CUSTOMER_RELATIONS;

        return this.baseDataService.query<GetDiscountGroupCustomerRelationsQuery, GetDiscountGroupCustomerRelationsQueryVariables>(
            fragment, {
            input: searchInput
        });
    }

    getItem(id: string): QueryResult<GetDiscountGroupCustomerRelationQuery> {
        return this.baseDataService.query<GetDiscountGroupCustomerRelationQuery, GetDiscountGroupCustomerRelationQueryVariables>(
            GET_DISCOUNT_GROUP_CUSTOMER_RELATION, {
            id: id
        });
    }

    async getItemData(id: string): Promise<DiscountGroupCustomerRelation> {
        return (await lastValueFrom(await this.getItem(id).mapSingle(x => x.getDiscountGroupCustomerRelation as DiscountGroupCustomerRelation)));
    }

    getItemStream(id: string): Observable<DiscountGroupCustomerRelation> {
        return this.getItem(id).mapStream(x => x.getDiscountGroupCustomerRelation as DiscountGroupCustomerRelation);
    }

    async saveItem(item: DiscountGroupCustomerRelationInput): Promise<DiscountGroupCustomerRelation> {
        // if (!item.type)
        //     item.type = DiscountGroupType.CUSTOMER;

        let validated = await this.systemService.validateObject<DiscountGroupCustomerRelationInput>(item, "DiscountGroupCustomerRelationInput");

        let saved = await lastValueFrom(await this.baseDataService.mutate<SaveDiscountGroupCustomerRelationMutation, SaveDiscountGroupCustomerRelationMutationVariables>(
            SAVE_DISCOUNT_GROUP_CUSTOMER_RELATION, {
            input: validated
        }));
        return saved.saveDiscountGroupCustomerRelation as DiscountGroupCustomerRelation;
    }

    async deleteItem(id: string): Promise<DeletionResponse> {
        let res = await lastValueFrom(await this.baseDataService.mutate<DeleteDiscountGroupCustomerRelationMutation, DeleteDiscountGroupCustomerRelationMutationVariables>(
            DELETE_DISCOUNT_GROUP_CUSTOMER_RELATION, {
            id: id
        }));

        return res.deleteDiscountGroupCustomerRelation;
    }
}